import { render, staticRenderFns } from "./housing.vue?vue&type=template&id=233d3c06&"
import script from "./housing.vue?vue&type=script&lang=js&"
export * from "./housing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports